module.exports = __webpack_public_path__ + "img/custom.99bebb06.png";